export default "__VITE_ASSET__CwU_8hD___"